import { render, staticRenderFns } from "./FormularioRegional.vue?vue&type=template&id=201429a8&lang=pug"
import script from "./FormularioRegional.vue?vue&type=script&lang=js"
export * from "./FormularioRegional.vue?vue&type=script&lang=js"
import style0 from "./FormularioRegional.vue?vue&type=style&index=0&id=201429a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports